import React, { Component } from 'react'
import { connect } from 'react-redux'
import SchemaEditor from './../SchemaEditor'
import parseSchemaFile from './parseSchemaFile'
import convertSchemaToFileContent from './convertSchemaToFileContent'
import { updateFileContent } from './../../../store/files/actions'

const mapStateToProps = (state, props) => {
  var branchId = props.branchId
  var branch = state.branches[branchId]
  var schemaFileId = branch.schema

  var newProps = {
    schemaFileId,
  }

  if (schemaFileId){
    var schemaContent = state.files[schemaFileId].text
    newProps.schemaContent = schemaContent
  }

  return newProps
}

const mapDispatchToProps = (dispatch, {
  branchId
}) => ({
  updateFileContent: (schemaFileId, content) => dispatch(updateFileContent(schemaFileId, content)),
})

class BranchEditContainer extends Component {

  updateSchema = (schema, type) => {
    const { updateFileContent, schemaFileId } = this.props
    var content = convertSchemaToFileContent(schema, type)
    updateFileContent(schemaFileId, content)
  };

  render = () => {

    const { schemaFileId, schemaContent, branchId } = this.props

    if (!schemaContent)
      throw new Error(`Expected 'schemaContent' to be passed in to this component`)

    // The file will likely be in one of three formats, it may be just a regular
    // JSON file but there's a good chance its an ES6 module or common js module
    // so for convience we will parse it to JSON but preserve the type of
    // module it is so that when we save it we can save it in the same format.
    const { type, schema } = parseSchemaFile(schemaContent)

    return <SchemaEditor
      branchId={branchId}
      schema={schema}
      onSchemaChange={(schema) => this.updateSchema(schema, type)}
    />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BranchEditContainer)


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/Container/Container.js